import React, { useCallback, useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { Navigate } from 'react-router-dom'
import styled from 'styled-components'

import StyledPageWrapper from './StyledPageWrapper/StyledPageWrapper'
import Header from '../components/Header/Header'
import ChangePasswordOverlay from '../components/Profile/ChangePasswordOverlay'

const StyleContainer = styled.div`
  margin-top: 0;
  min-height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
`

const PrivateRoute = observer(({ loginStore, profileStore, children }) => {
  const { logoutRedirecting } = loginStore

  const resetLogoutRedirecting = useCallback(() => {
    loginStore.logoutRedirecting = false
  }, [loginStore])

  useEffect(() => {
    if (logoutRedirecting) {
      const timer = setTimeout(resetLogoutRedirecting, 1500)
      return () => clearTimeout(timer)
    }
  }, [logoutRedirecting, resetLogoutRedirecting])

  if (logoutRedirecting) return null

  if (!loginStore.isUserLoggedIn) return <Navigate to='/login' />

  return (
    <>
      <StyledPageWrapper>
        <Header />
        <StyleContainer>{children}</StyleContainer>
      </StyledPageWrapper>

      {profileStore.profile.forcePasswordChange && <ChangePasswordOverlay />}
    </>
  )
})

export default inject('loginStore', 'profileStore')(PrivateRoute)
